import { useState } from 'react';
import SearchIcon from '../icons/searchIcon';
import ClickAwayListener from '../ClickAwayListener';

export function SearchSelect({
  placeholder,
  items = [],
  loading = false,
  onChangeText,
  onSelect,
  getLabel,
  t,
}) {
  const [showTripResults, setShowTripResults] = useState(false);
  const [highlightIndex, setHighlightIndex] = useState(-1);

  const handleSelect = (item) => {
    if (!item) return;
    setShowTripResults(false);
    setHighlightIndex(-1);
    onSelect?.(item);
  };

  const handleKeyDown = async (e) => {
    const { key } = e;

    if (key === 'ArrowDown' || key === 'ArrowUp') {
      if (!showTripResults && items.length > 0) {
        setShowTripResults(true);
      }

      if (items.length === 0) return;

      e.preventDefault();
      setHighlightIndex((prev) => {
        if (key === 'ArrowDown') {
          const next = prev + 1;
          return next >= items.length ? 0 : next;
        } else {
          const next = prev - 1;
          return next < 0 ? items.length - 1 : next;
        }
      });
      return;
    }

    if (key === 'Enter') {
      if (highlightIndex >= 0 && highlightIndex < items.length) {
        e.preventDefault();
        handleSelect(items[highlightIndex]);
      }
      return;
    }

    if (key === 'Escape') {
      setShowTripResults(false);
      setHighlightIndex(-1);
      return;
    }

    // Búsqueda normal por texto (delegada hacia fuera)
    const value = e.target.value ?? '';
    const trimmed = value.trim();

    if (!trimmed) {
      setShowTripResults(false);
      setHighlightIndex(-1);
      onChangeText?.(trimmed);
      return;
    }

    if (!showTripResults) {
      setShowTripResults(true);
    }

    setHighlightIndex(items.length > 0 ? 0 : -1);
    onChangeText?.(trimmed);
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        setShowTripResults(false);
        setHighlightIndex(-1);
      }}
    >
      <div className="relative flex items-center h-10">
        <span className="absolute left-3 text-gray-400">
          <SearchIcon className="w-4 h-4" />
        </span>
        <input
          type="text"
          name="trip"
          placeholder={placeholder}
          className="w-full h-10 pl-10 pr-3 text-xs border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-primary-400 focus:border-transparent"
          autoComplete="off"
          onFocus={() => {
            if (items.length > 0) {
              setShowTripResults(true);
            }
          }}
          onKeyUp={handleKeyDown}
        />
        {showTripResults && (
          <div className="absolute top-full left-0 mt-1 w-full bg-white border border-gray-200 rounded shadow-lg max-h-60 overflow-auto text-xs z-50">
            {loading && (
              <div className="px-4 py-2.5 text-gray-500 text-xs">
                {t ? t('Searching') : 'Searching...'}
              </div>
            )}
            {!loading && items.length === 0 && (
              <div className="px-4 py-2.5 text-gray-500 text-xs">
                {t ? t('No results') : 'No results'}
              </div>
            )}
            {!loading &&
              items.map((item, index) => {
                const label =
                  (getLabel && getLabel(item)) ||
                  item.label ||
                  item.text ||
                  item.tripNumber ||
                  String(item);

                return (
                  <div
                    key={item.id ?? index}
                    className={`px-4 py-2.5 text-xs cursor-pointer ${index === highlightIndex
                        ? 'bg-gray-100 text-gray-900'
                        : 'hover:bg-gray-50 text-gray-700'
                      }`}
                    onMouseDown={(e) => {
                      // evitar que el input pierda el foco antes de seleccionar
                      e.preventDefault();
                      handleSelect(item);
                    }}
                  >
                    {label}
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
}

export default SearchSelect;